'use client';

import { useTenantAndVariant } from '@multitenancy/TenantAndVariantContext';

const storeDescriptions: Record<string, { tagline: string; description: string; mission: string }> = {
  annietime: {
    tagline: 'Where quality meets style.',
    description: 'We curate the finest selection of products to bring you timeless elegance and contemporary fashion.',
    mission: 'Our mission is to provide you with exceptional products that blend traditional craftsmanship with modern aesthetics.',
  },
  aussiestyle: {
    tagline: 'Australian style, global quality.',
    description: 'We bring you the best of Australian-inspired fashion and lifestyle products.',
    mission: 'Our mission is to deliver quality products that celebrate the spirit and style of Australia.',
  },
  fun: {
    tagline: 'Everything your pet needs — and more!',
    description: 'We offer a wide range of premium pet products for cats, dogs, and more. From toys to treats, we have it all.',
    mission: 'Our mission is to keep your furry friends happy, healthy, and entertained with quality products at great prices.',
  },
};

export function AboutSection() {
  const { storeConfig } = useTenantAndVariant();
  const desc = storeDescriptions[storeConfig.name] || storeDescriptions.annietime;

  return (
    <section className="py-20 bg-white">
      <div className="container">
        <div className="max-w-4xl mx-auto text-center">
          <h2 className="text-3xl md:text-4xl font-light mb-8 tracking-[0.15em] uppercase text-[#2B2C2D]">
            About {storeConfig.displayName}
          </h2>
          <div className="space-y-6 text-gray-700 leading-relaxed">
            <p className="text-lg">
              Welcome to {storeConfig.displayName}. {desc.tagline} {desc.description}
            </p>
            <p>{desc.mission}</p>
            <p>Visit us and discover a world of quality and great value.</p>
          </div>
        </div>
      </div>
    </section>
  );
}
